const mediaImages = [
  'aroma1.png',
  'aroma2.png',
  'aroma3.png',
  'aroma4.png',
  'aroma5.png',
  'aroma6.png',
  'aroma7.png',
  'aroma8.png',
  'aroma9.png',
  'aroma10.png',
  'aroma11.png',
  'aroma12.png',
  'aroma13.png',
  'aroma14.png',
  'aroma15.png',
  'aroma16.png',
  'aroma17.png',
  'aroma18.png',
  'aroma19.png',
  'aroma20.png',
  'aroma21.png',
  'aroma22.png',
  'aroma23.png',
  'aroma24.png',
  'aroma25.png',
  'aroma26.png',
  'aroma27.png',
  'aroma28.png',
  'aroma29.png',
  'aroma30.png',
  'aroma31.png',
  'aroma32.png',
  'aroma33.png',
  'aroma34.png',
  'aroma35.png',
  'aroma36.png',
  'aroma37.png',
  'aroma38.png',
  'aroma39.png',
  'aroma40.png',
  'aroma41.png',
  'aroma42.png',
  'aroma43.png',
  'aroma44.png',
  'aroma45.png',
  'aroma46.png',
  'aroma47.png',
  'aroma48.png',
];

export default mediaImages;
